$(function() {
	$('.change-client-status').click(function(){
		var checks = $('.clients input[type=checkbox]:checked');

		// nothing selected
		if( checks.length == 0 ) {
			alert('No clients selected.');
			return false;
		}

		var is_disabled = $(this).attr('data-disabled');
		var label = is_disabled == "y" ? 'disable' : 'activate';

		// confirm
		if( !confirm('Are you sure you want to ' + label + ' selected clients?') ) {
			return false;
		}
		
		// get the selected ids
		var ids = [];
		var trs = [];
		checks.each(function(){
			var tr = $(this).parents('tr');
			trs.push( tr );
			ids.push( tr.attr('data-id') );
		});

		$.post('/clients/change-status', {'ids' : ids.join(','), 'is_disabled' : is_disabled}, function(){
			$(trs).each(function(){
				if( is_disabled == "y" ) {
					$(this).addClass('disabled-client');				
				}else {
					$(this).removeClass('disabled-client');
				}
			});

			checks.attr('checked', false);
			checks.trigger('change');
		});
	});
});